"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptRunnerType = void 0;
var ScriptRunnerType;
(function (ScriptRunnerType) {
    ScriptRunnerType["KahbaRunner"] = "kahba";
    ScriptRunnerType["TaskRunner"] = "tasks";
})(ScriptRunnerType = exports.ScriptRunnerType || (exports.ScriptRunnerType = {}));
//# sourceMappingURL=script-runner.js.map